import api from './api';

export const promptsService = {
  getPrompts: async () => {
    const response = await api.get('/api/prompts');
    return response.data;
  },

  getPrompt: async (id) => {
    const response = await api.get(`/api/prompts/${id}`);
    return response.data;
  },

  createPrompt: async (prompt) => {
    const response = await api.post('/api/prompts', prompt);
    return response.data;
  },

  updatePrompt: async (id, prompt) => {
    const response = await api.put(`/api/prompts/${id}`, prompt);
    return response.data;
  },

  deletePrompt: async (id) => {
    const response = await api.delete(`/api/prompts/${id}`);
    return response.data;
  },

  deleteMultiplePrompts: async (ids) => {
    const response = await api.post('/api/prompts/batch/delete', ids);
    return response.data;
  },
};
